"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_AREA_ID = exports.ROOT_WRAPPER = void 0;
const ROOT_WRAPPER = exports.ROOT_WRAPPER = 'root-wrapper';
const TOP_AREA_ID = exports.TOP_AREA_ID = 'top-area';